import React, { Component } from 'react';
import { reduxForm, Field, initialize } from 'redux-form';
import { Accordion, Grid } from 'semantic-ui-react';
import * as _ from 'lodash';

import { SelectField, InputField } from 'Common/SemanticWrapper';
import { USER_ACCESS_ROLE_FORM } from 'Common/FormEnum';
import { FieldEnum } from 'Common/FieldEnum';
import { GroupRoot } from './components/GroupRoot';
import { DirtyWrapper } from '../../components';
import {
  mapIconToGroup,
  formatRolesForSelect,
  buildValuesFromGroup,
} from './helpers/';

class Form extends Component {
  state = {
    roleId: null,
    selectedRole: null,
  };

  componentDidMount() {
    this.checkRoleId();
  }

  componentDidUpdate() {
    this.checkRoleId();
  }

  checkRoleId() {
    const { roleId } = this.props;
    const { roleId: localRoleId } = this.state;

    if ((!localRoleId && !roleId) || localRoleId !== roleId) {
      this.initializeValues();
    }
  }

  initializeValues() {
    const { roleId, rawData, dispatch } = this.props;

    dispatch(
      initialize(
        USER_ACCESS_ROLE_FORM,
        {
          roleId: roleId,
          ...buildValuesFromGroup(rawData),
        },
        false
      )
    );

    this.setState({
      roleId: roleId,
    });
  }

  setSelectedRole = () => {
    this.props.change(FieldEnum.UserRoleAccessRole, this.state.selectedRole);
  };

  render() {
    const {
      activeIndex,
      setActiveIndex,
      handleSubmit,
      groups,
      roles = [{ Id: 0 }],
      dispatch,
      formValues,
    } = this.props;

    return (
      <form onSubmit={handleSubmit}>
        <div className="user-role-access--role">
          <Grid>
            <Grid.Row columns={3}>
              <Grid.Column>
                <DirtyWrapper closeModalYesCallback={this.setSelectedRole}>
                  {showDirtyConfirm => (
                    <Field
                      fluid
                      component={SelectField}
                      name={FieldEnum.UserRoleAccessRole}
                      label={<label className="text-orange">Role</label>}
                      value={roles[0].Id}
                      options={formatRolesForSelect(roles)}
                      onChange={(e, selectedRole) => {
                        e.preventDefault();
                        this.setState({ selectedRole }, showDirtyConfirm);
                      }}
                    />
                  )}
                </DirtyWrapper>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
        <div className="user-role-access--access">
          <label className="text-orange">Access</label>
          <Accordion styled>
            {_.sortBy(Object.keys(groups), key => groups[key][0].Ordinal).map(
              key => (
                <GroupRoot
                  dispatch={dispatch}
                  index={key}
                  key={key}
                  title={key}
                  group={groups[key]}
                  icon={mapIconToGroup(key)}
                  setActiveIndex={setActiveIndex}
                  activeIndex={activeIndex}
                  formValues={formValues}
                />
              )
            )}
          </Accordion>
        </div>
        <Field name="redraw" type="hidden" component={InputField} />
      </form>
    );
  }
}

export default reduxForm({
  destroyOnUnmount: false,
  enableReinitialize: true,
  form: USER_ACCESS_ROLE_FORM,
})(Form);



// WEBPACK FOOTER //
// ./src/pages/userroleaccess/Form.js